const masterDataCatalog = () => import('@/views/pages/masterData/masterDataCatalog/index.vue');
const MasterDataDetail = () => import('@/views/pages/masterData/masterDataCatalog/masterDataDetail/index.vue');

const EntityDetail = () => import('@/views/pages/masterData/masterDataCatalog/entityDetail/index.vue');

const masterDataEntityOverview = () => import('@/views/pages/masterData/masterDataEntityOverview/index.vue');

const attributeDetail = () => import('@/views/pages/masterData/masterDataCatalog/attributeDetail/index.vue');

const DataFlowView = () => import('@/views/pages/masterData/dataFlowView/index.vue');

const TrustedSource = () => import('@/views/pages/masterData/trustedSource/index.vue');

const MasterDataService = () => import('@/views/pages/masterData/MasterDataService/index.vue');

const MasterDataRouteList = [
  {
    path: 'masterDataCatalog',
    component: masterDataCatalog,
    name: '/masterDataCatalog',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Mater Data Catalog',

      mid: '7f49-b0c6',
    },
  },
  {
    path: 'masterDataDetail',
    component: MasterDataDetail,
    name: '/masterDataDetail',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Mater Data Detail',

      mid: '3b6a-d8e1',
    },
  },
  {
    path: 'entityDetail',
    component: EntityDetail,
    name: '/entityDetail',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Entity Detail',

      mid: '0a9d-7f24',
    },
  },
  {
    path: 'masterDataEntityOverview',
    component: masterDataEntityOverview,
    name: '/masterDataEntityOverview',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Master Data Logical Entity Overview',

      mid: 'c8e5-1b69',
    },
  },
  {
    path: 'attributeDetail',
    component: attributeDetail,
    name: '/attributeDetail',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Atrribute Detail',

      mid: '5f2a-9c83',
    },
  },
  {
    path: 'dataFlowView',
    component: DataFlowView,
    name: '/dataFlowView',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Data Flow View',
      mid: 'd7b0-4e16',
    },
  },
  {
    path: 'trustedSource',
    component: TrustedSource,
    name: '/trustedSource',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Trusted Source',
      mid: '9a1c-6f3d',
    },
  },
  {
    path: 'masterDataService',
    component: MasterDataService,
    name: '/masterDataService',
    meta: {
      ownType: 'MasterData',
      lableTitle: 'Master Data Service',
      mid: '2e4b-8d90',
    },
  },
];

export default MasterDataRouteList;
